import { render, staticRenderFns } from "./PurposesRentingAreasItemList.vue?vue&type=template&id=ed830bd8&scoped=true&"
import script from "./PurposesRentingAreasItemList.vue?vue&type=script&lang=js&"
export * from "./PurposesRentingAreasItemList.vue?vue&type=script&lang=js&"
import style0 from "./PurposesRentingAreasItemList.vue?vue&type=style&index=0&id=ed830bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed830bd8",
  null
  
)

export default component.exports